import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import { DetailsLayout, Text } from '../../common';
import { MEDICATION_TYPES } from '../constants';

function MedicationDetails({
  activeNumerator,
  activeNumeratorUnit,
  datePrescribed,
  dosage,
  frequency,
  frequencyUnit,
  name,
  notes,
  alternateName,
  prescribingDoctor,
  pharmacy,
  prn,
  route,
  type,
}) {
  var formatedName = name;
  if (alternateName) {
    formatedName += ` (${alternateName})`;
  }
  const formatedDatePrescribed = datePrescribed
    ? format(datePrescribed, 'M/D/YYYY')
    : '';

  return (
    <DetailsLayout heading={`${formatedName}`}>
      <Text>
        {type}
        {!!activeNumerator && `, ${activeNumerator} ${activeNumeratorUnit}`}
        {type &&
          type !== MEDICATION_TYPES.PILL &&
          type !== MEDICATION_TYPES.OTHER &&
          activeNumeratorUnit !== 'Other' &&
          ' per mL(cc)'}
      </Text>
      <Text>
        {!!dosage && `Dosage: ${dosage}`}
        {!!dosage &&
          type &&
          type !== MEDICATION_TYPES.PILL &&
          type !== MEDICATION_TYPES.OTHER &&
          activeNumeratorUnit !== 'Other' &&
          ' mL(cc)'}
      </Text>
      <Text>{route && `by ${route}`}</Text>
      <Text>
        {!!frequency && `${frequency} times per ${frequencyUnit}`}
        {prn && !!frequency && ', '}
        {prn && 'PRN (as needed)'}
      </Text>
      {pharmacy && pharmacy.pharmacyName && (
        <Text>Pharmacy: {pharmacy.pharmacyName}</Text>
      )}
      {prescribingDoctor &&
        (prescribingDoctor.firstName || prescribingDoctor.lastName) && (
          <Text>
            Doctor: {prescribingDoctor && prescribingDoctor.firstName}{' '}
            {prescribingDoctor && prescribingDoctor.lastName}
          </Text>
        )}
      {formatedDatePrescribed && (
        <Text>Date Prescribed: {formatedDatePrescribed}</Text>
      )}
      {notes && (
        <div>
          <Text>Notes: </Text>
          <Text>{notes}</Text>
        </div>
      )}
    </DetailsLayout>
  );
}

MedicationDetails.propTypes = {
  name: PropTypes.string.isRequired,
  activeNumerator: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  activeNumeratorUnit: PropTypes.string,
  alternateName: PropTypes.string,
  datePrescribed: PropTypes.string,
  dosage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  frequency: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  frequencyUnit: PropTypes.string,
  notes: PropTypes.string,
  pharmacy: PropTypes.shape({
    pharmacyName: PropTypes.string,
  }),

  prescribingDoctor: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  prn: PropTypes.bool,
  route: PropTypes.string,
  type: PropTypes.string,
};

export default MedicationDetails;



// WEBPACK FOOTER //
// ./src/modules/MedicationPage/components/MedicationDetails.js